<!--企业注册-->
<template>
   <div>
      <!-- 申请提交 -->
      <div style="width: 1400px;margin-left: auto;margin-right: auto;">
         <!-- 标题 -->
         <div class="formHead">
            <h4>填写注册信息</h4>
         </div>
         <!-- 表单区域 -->
         <div class="form_body">
            <p class="p-title">单位基本信息</p>
            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
               <div data-v-022fc800="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>单位名称:</span>
                  <div class="innerP" style="width: auto; font-size: 14px;">
                     <div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
                        <el-select v-model="form.name" filterable remote reserve-keyword
                                   placeholder="请输入关键词"
                                   :remote-method="remoteMethod" :loading="loading" @change="choose"
                                   style="width: 100%">
                           <el-option v-for="(item,i) in comoptions" :key="i" :label="item.label"
                                      :value="item.value">
                           </el-option>
                        </el-select>
                     </div>
                  </div>
               </div>
               <div data-v-022fc800="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>社会信用代码:</span>
                  <div class="innerP" style="width: auto; font-size: 14px;">
                     <div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
                        <el-input v-model.trim="form.tax_number"/>
                     </div>
                  </div>
               </div>
               <!-- 插入两条下拉选项 -->
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="18" spanTitle="通讯地址" normalPlace="请输入通讯地址"
                            @inputChange="labelInput($event,'address')">
               </label-input>
               <div class="labelInput" style="width: 500px">
						<span data-v-022fc800="" class="innerSpan"
                        style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span data-v-022fc800="" style="color: red;">*&nbsp;</span>企业注册地:</span>
                  <el-select size="small" style="width: 150px;margin-left: 20px" v-model="province"
                             placeholder="请选择省份" v-on:change="getProv($event)">
                     <el-option v-for="item in provs" :label="item.label" :key="item.value" :value="item.value">
                     </el-option>
                  </el-select>
                  <el-select size="small" style="width: 150px;margin-left: 20px" v-if="province!=''"
                             v-model="form.register_address" placeholder="请选择城市"
                             v-on:change="getCity($event)">
                     <el-option v-for="item in citys" :label="item.label" :key="item.value" :value="item.value">
                     </el-option>
                  </el-select>
               </div>

               <label-input v-if="false" :spanRequired="true" :spanWidth="spanWidth" specilType="limit" :maxLimit="10"
                            componentWidth="500px" spanTitle="法人代表" normalPlace="请输入法人代表"
                            @inputChange="labelInput($event,'legal_person')">
               </label-input>
               <label-input v-if="false" :spanRequired="true" spanTitle="联系电话" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="40" componentWidth="500px" normalPlace="请输入联系电话"
                            @inputChange="labelInput($event,'phone')"></label-input>
               <label-input v-if="false" :spanRequired="false" :spanWidth="spanWidth" componentWidth="500px"
                            spanTitle="企业网址"
                            normalPlace="请输入" @inputChange="labelInput($event,'site_url')">
               </label-input>
            </div>
         </div>

         <div class="form_body">
            <p class="p-title">用户基本信息</p>
            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
               <div data-v-022fc800="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>登录账号:</span>
                  <div class="innerP" style="width: auto; font-size: 14px;">
                     <div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
                        <el-input v-model.trim="form.login_account" disabled="true"/>
                     </div>
                  </div>
               </div>
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="11" spanTitle="手机号码" normalPlace="请输入真实手机号,用于接收相关消息通知"
                            @inputChange="labelInput($event,'cellphone')">
               </label-input>
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="10" spanTitle="真实姓名" normalPlace="请输入联络人姓名"
                            @inputChange="labelInput($event,'username')">
               </label-input>
               <label-input componentWidth="500px" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="50" spanTitle="电子邮箱" normalPlace="请输入"
                            @inputChange="labelInput($event,'email')">
               </label-input>
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth"
                            specilType="password" spanTitle="用户密码" normalPlace="请输入用户密码"
                            @inputChange="labelInput($event,'password')"></label-input>
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth"
                            specilType="password" spanTitle="密码确认" normalPlace="请输入密码"
                            @inputChange="labelInput($event,'password2')"></label-input>
               <div style="width: 100%;color: #FE2e2c;font-size: 14px;padding-left: 108px;">
                  <p>提示：密码长度6-24位，至少包含字母、数字、字符任意两种组合</p>
               </div>
               <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="20" spanTitle="工作部门" normalPlace="请输入"
                            @inputChange="labelInput($event,'dep')">
               </label-input>
               <label-input componentWidth="500px" :spanRequired="false" :spanWidth="spanWidth" specilType="limit"
                            :maxLimit="20" spanTitle="工作职务" normalPlace="请输入"
                            @inputChange="labelInput($event,'post')">
               </label-input>
            </div>
         </div>
         <div class="form_button">
            <el-button @click="$router.go(-1)">返回</el-button>
            <el-button type="primary" style="background-color: #015aaa;" @click="submitApp()">提交</el-button>
         </div>
      </div>

      <!-- 提交成功 -->
      <div>
         <el-dialog :visible.sync="dialogVisible" width="282px" :show-close="false" :modal="false" top="420px">
            <div class="" style="display: flex;flex-flow: column;justify-content: center;align-items: center;">
               <img src="../../assets/img/login/submit.png" style="width: 40px;height: 40px;margin-bottom: 20px;">
               <span>{{ Msg }}</span>
               <!-- <span>如有疑问可联系68048993</span>-->
            </div>
         </el-dialog>
      </div>
      <!-- 注册成功 -->
      <el-dialog :visible.sync="centerDialogVisible" width="400px" :close-on-click-modal="false"
                 :close-on-press-escape="false" center>
         <div class="dialogTip">
            <img src="../../assets/img/login/submit.png" alt="">
            <p style="font-size: 24px;font-weight: bold;margin-top: 10px;">恭喜您注册成功</p>
            <p style="margin-top: 10px;">您的账户为：<span
                  style="color: #0070C0;font-size: 20px;font-weight: bold;">{{ form.login_account }}</span></p>
            <p style="margin-top: 10px;">请妥善保管您的账户信息</p>
            <el-button style="margin-top: 20px;" @click="$router.replace('/index')">去登录</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
   import labelInput from "../../components/table/labelInput.vue"
   import {getProvince, getCityByProvince} from "@/utils/city";
   import {userRegister} from "@/api/modules/company.js"
   import {getCompanyNames, getTaxNumber} from '@/api/modules/company'
   import {vaildte} from '../../utils/validate.js'
   import CryptoJs from "crypto-js";
   import prjConfig from "@/utils/prjConfig";

   export default {
      data() {
         return {
            centerDialogVisible: false,
            province: '',
            city: '',
            provs: [],
            citys: [],
            cityChoose: 1,
            form: {
               name: '',
               login_account: '自动生成',
               tax_number: '',
               address: '',
               register_address: '',
               legal_person: '',
               qualification_level: '',
               member_category: '',
               phone: '',
               cellphone: '',
               site_url: '',
               username: '',
               password: '',
               password2: '',
               post: '',
               dep: '',
               email: '',
               password_answer: '',
               password_question: '',
            },
            comoptions: [],
            loading: false,
            Msg: '提交成功，请等待审核',
            dialogVisible: false,
            spanWidth: '130px',

            componentWidth: '740px',
            //绿色工程18
            typeId: prjConfig.portalType
         }
      },
      components: {
         labelInput,
      },
      created() {
         let cityChoose = localStorage.getItem('cityChoose')
         this.cityChoose = cityChoose
         this.provs = getProvince();
      },
      methods: {
         getProv: function (prov) {
            this.citys = [];
            this.form.register_address = '';
            this.citys = getCityByProvince(prov);
         },
         getCity: function (city) {
            // console.log(city);
         },
         //公司名模糊查询
         async remoteMethod(query) {
            if (query !== '') {
               let keyword = query
               await getCompanyNames({
                  data: {
                     compName: keyword
                  },
                  success: (res) => {
                     let data = res.data
                     console.info('单位返回数据', data);
                     this.list = data.map(item => {
                        return {
                           value: `${item}`,
                           label: `${item}`
                        };
                     });
                     this.loading = true;
                     setTimeout(() => {
                        this.loading = false;
                        this.comoptions = this.list.filter(item => {
                           return item.label.toLowerCase()
                                 .indexOf(query.toLowerCase()) > -1;
                        });
                     }, 200);
                  },
                  fail: (err) => {
                     console.log(err)
                  }
               })
            } else {
               this.comoptions = [];
            }
         },
         //选择公司名称
         choose(value) {
            this.form.name = value
            const {
               data
            } = this.getnum()
            this.form.tax_number = data
         },
         //获取社会代码
         async getnum() {
            let keyword = this.form.name
            await getTaxNumber({
               data: {
                  compName: keyword
               },
               success: (res) => {
                  this.form.tax_number = res.data
               },
               fail: (err) => {
                  console.log(err)
               }
            })
         },
         labelInput(e, name) {
            this.form[name] = e
         },

         // 提交申请
         async submitApp() {
            // 非空判断
            if (this.form.address == '' ||
                  this.form.name == '' ||
                  this.form.password == '' ||
                  this.form.password2 == '' ||
                  this.form.tax_number == '' ||
                  this.form.cellphone == '' ||
                  this.form.dep == ''
            ) {
               this.$message.error('存在未填写项');
               return false
            }
            if (!vaildte.isPhone(this.form.cellphone)) {
               this.$message.error('手机号码填写不符合格式');
               return false
            }
            if (!vaildte.isBlank(this.form.email) && !vaildte.isEmail(this.form.email)) {
               this.$message.error('电子邮箱填写不符合格式');
               return false
            }
            // 密码验证
            if (this.form.password.length > 5 && this.form.password.length < 25) {
               const rgx = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)/
               if (!rgx.test(this.form.password)) {
                  this.$message.error('用户密码不符合要求，密码长度6-24位，至少包含字母、数字、字符任意两种组合')
                  return
               }
            } else if (this.form.password.length > 24) {
               this.$message.error('用户密码长度不超过24位')
               return
            } else {
               this.$message.error('用户密码长度不低于6位')
               return
            }
            if (this.form.password !== this.form.password2) {
               this.$message.error('用户密码与确认密码不相等')
               return
            }
            this.form.portalType = this.typeId
            await userRegister({
               data: this.form,
               success: (res) => {
                  if (res.code == '500') {
                     this.$message({
                        message: res.msg,
                        type: 'error'
                     });
                     return false
                  } else {
                     this.form.login_account = res.data.loginAccount;
                     this.centerDialogVisible = true
                     this.$message({
                        message: res.msg,
                        type: 'success'
                     });
                  }
               },
               fail: (err) => {
                  console.log(err)
               }
            })
         },
         handleClose() {
            this.$router.replace('/login')
         }
      }
   }
</script>

<style scoped>
   body {
      background-color: #FFFFFF;
   }

   .dialogTip {
      min-height: 350px;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
   }

   >>> .el-dialog {
      border-radius: 18px;
      overflow: hidden;
   }

   .p-title {
      color: #035bab;
      font-size: 16px;
      font-weight: 600;
   }

   >>> .el-dialog__header {
      display: none;
   }

   >>> .el-dialog__body {
      padding: 20px 50px;
   }

   /* form页面 */
   .formHead {
      height: 130px;
      width: 100%;
      display: flex;
      flex-flow: column;
      justify-content: space-evenly;
      align-items: center;
   }

   .formHead h4 {
      font-size: 24px;
      letter-spacing: 1px;
      font-weight: bold;
      color: #0070C0;
   }

   .formHead_title {
      height: 30px;
      line-height: 30px;
      background-color: #ffece6;
      color: #FE2e2c;
      width: 100%;
      display: flex;
      align-items: center;
   }

   .formHead_title img {
      width: 15px;
      height: 15px;
      margin-left: 40px;
      margin-right: 10px;
   }

   /* 表单主体 */
   .form_body {
      width: 1250px;
      margin-left: auto;
      margin-right: auto;
      height: 100%;
   }

   .form_body2 {
      width: 1250px;
      height: 185px;

      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
   }

   .form_body3 {
      min-height: 120px;
      height: auto;
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
   }

   .tbody {
      margin-top: 20px;
      padding: 30px 0;
   }

   .form_button {
      height: 150px;
      display: flex;
      justify-content: center;
   }

   .form_button button {
      margin-top: auto;
      margin-bottom: auto;
      width: 200px;
      height: 35px;
   }

   .body_inner {
      width: 50%;
   }

   /* 消除弹窗头部区域 */
   .el-dialog__header {
      display: none;
   }
</style>
